module.exports = __webpack_public_path__ + "static/media/hs_16.9db5968b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_16.jpg
// module id = 5947
// module chunks = 0